import { defineAction } from '~/prix'
import { z } from 'zod'
import veterinaryCareUpdateAction from './veterinaryCareUpdate.action.json' with { type: 'json' }
import { veterinaryCareObject } from '../veterinaryCareObject'
import { veterinaryExamObject } from '../../veterinaryExam/veterinaryExamObject'
import { veterinarySymptomObject } from '../../veterinarySymptom/veterinarySymptomObject'
import { veterinaryMedicationObject } from '../../veterinaryMedication/veterinaryMedicationObject'

const veterinaryCareUpdateDefinition = defineAction({
  ...veterinaryCareUpdateAction,

  input: veterinaryCareObject.partial().extend({
    id: veterinaryCareObject.shape.id,
    veterinaryExamIds: z.array(veterinaryExamObject.shape.id),
    veterinarySymptomIds: z.array(veterinarySymptomObject.shape.id),
    medications: z.array(
      veterinaryMedicationObject.pick({
        name: true,
        quantity: true,
        quantityUnit: true,
        observations: true,
      }),
    ),
  }),
  output: z.object({}),
})

export default veterinaryCareUpdateDefinition
